import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-lost-password',
    templateUrl: './page-lost-password.component.html',
    styleUrls: ['./page-lost-password.component.scss'],
    standalone: false
})
export class PageLostPasswordComponent implements OnInit {

  form = {
    email: '',
  };

  constructor() { }

  ngOnInit(): void {
  }

}
